import classNames from 'classnames'
import React from 'react'

type Props = {
    label: string
    className?: string
    shrinked?: boolean
    genomateThemed?: boolean
    onClick?: (event: any) => void
}

const LinkButton: React.FC<Props> = ({
    label,
    className,
    onClick,
    shrinked,
    genomateThemed
}) => (
    <button
        type="button"
        className={classNames(
            'linkButton',
            'defaultButton',
            'defaultButton--inverse',
            className,
            {
                'defaultButton--shrinked': shrinked,
                genomate: genomateThemed
            }
        )}
        onClick={onClick}
    >
        {label}
    </button>
)

export default LinkButton
